module.exports = __webpack_public_path__ + "img/faqs-img.e8cdf42.png";